export default "__VITE_ASSET__C_Xk94hB__"